export default __webpack_public_path__ + "static/media/45.9047ff3d.svg";